import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { ApiFragment } from '@stylehaven/components';
import { AccessibleMiddleware } from './accessible.middleware.service';
import { ContextMiddleware } from './context.middleware';
import { MiddlewareService } from './middleware.abstract.service';
import { ProfileMiddleware } from './profile.middleware.service';

@Injectable({ providedIn: 'root' })
export class AggregateMiddleware implements MiddlewareService {
    constructor(
        private readonly profileMiddleware: ProfileMiddleware,
        private readonly contextMiddleware: ContextMiddleware,
        private readonly accessibleMiddleWare: AccessibleMiddleware
    ) {}

    annotate(record: ApiFragment): Observable<ApiFragment> {
        return this.accessibleMiddleWare.annotate(record).pipe(
            switchMap(accessibleRecord => this.profileMiddleware.annotate(accessibleRecord)),
            switchMap(withProfiles => this.contextMiddleware.annotate(withProfiles)),
            catchError(error => {
                return throwError(error);
            })
        );
    }
}
